import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { 
  Typography, 
  Box,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import PullRequestsTab from './PullRequestsTab';
import DailyExecutionTab from './DailyExecutionTab';
import TestInstancesView from './TestInstancesView';
import InstanceManagementView from './InstanceManagementView';

/**
 * QualityAssuranceView component for displaying quality assurance metrics and activities
 * @returns {JSX.Element} QualityAssuranceView component
 */
const QualityAssuranceView = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(0);
  const [pullRequestSubTab, setPullRequestSubTab] = useState(0);

  // Check if tab parameter is in URL
  useEffect(() => {
    try {
      const tabParam = searchParams.get('tab');
      if (tabParam === 'test-instances') {
        setActiveTab(1);
      } else if (tabParam === 'instance-management') {
        setActiveTab(2);
      } else {
        setActiveTab(0);
      }
    } catch (error) {
      console.warn('Error reading tab parameter:', error);
      setActiveTab(0);
    }
  }, [searchParams]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handlePullRequestSubTabChange = (event, newValue) => {
    setPullRequestSubTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%' }}>
      <Box mb={3}>
        <Typography variant="h4" gutterBottom>
          Quality Assurance
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Comprehensive quality assurance framework and metrics
        </Typography>
      </Box>

      <Paper 
        elevation={2} 
        sx={{ 
          width: '100%', 
          maxWidth: '100%',
          borderRadius: 2,
          border: '1px solid rgba(0, 0, 0, 0.06)',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            variant="fullWidth"
          >
            <Tab label="Pull Requests" />
            <Tab label="Test Instances" />
            <Tab label="Instance Management" />
          </Tabs>
        </Box>

        {activeTab === 0 && (
          <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={pullRequestSubTab}
                onChange={handlePullRequestSubTabChange}
                variant="fullWidth"
              >
                <Tab label="Impacted Tests" />
                <Tab label="Daily Execution" />
              </Tabs>
            </Box>
            <Box sx={{ p: 3 }}>
              {pullRequestSubTab === 0 && <PullRequestsTab />}
              {pullRequestSubTab === 1 && <DailyExecutionTab />}
            </Box>
          </>
        )}
        {activeTab === 1 && (
          <Box sx={{ p: 3 }}>
            <TestInstancesView />
          </Box>
        )}
        {activeTab === 2 && (
          <Box sx={{ p: 3 }}>
            <InstanceManagementView />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default QualityAssuranceView;
